import React from 'react'
import styled from 'styled-components'
import LoadInView from '../../common/LoadInView'
import CardBtn from '../../common/CardBtn'
import Book from '../../../img/book.png'
import Chart from '../../../img/pichart.svg'


const AdminCard = () => {
  return (
    <Container>
        <LoadInView>
            <div>관리자페이지:시스템: 데이터보기</div>
            <ButtonGridContainer>
                <CardBtn
                    title='학문프로파일 보기'
                    desc='학문프로파일을 계열별, 영역별, 학과별로 살펴보세요.'
                    img={Book}
                    goto='/admin/system/view/profile'
                />
                <CardBtn
                    title='대시보드 보기'
                    desc='학문프로파일을 수치로 정리한 자료를 살펴보세요.'
                    img={Chart}
                    goto='/admin/system/view/dashborad'
                />
                <CardBtn
                    title='학과분류체계 보기'
                    desc='학과분류체계를 살펴보세요.'
                    img={Chart}
                    goto='/admin/system/view/codebook'
                />
            </ButtonGridContainer>
        </LoadInView>
        <br />
        <br />
        <br />
        <br />
        <LoadInView>
            <div>관리자페이지:시스템: 분석</div>
            <ButtonGridContainer>
                <CardBtn
                    title='학문프로파일 분석자료 보러가기'
                    desc='학과프로파일을 시각화한 자료를 살펴보세요.'
                    img={Chart}
                    goto='/admin/system/visualize'
                />
                <CardBtn
                    title='토픽모델링하기'
                    desc='토픽모델링을 활용해 학문프로파일을 분석해보세요.'
                    img={Chart}
                    goto="/admin/system/tpc-modeling"
                />
                <CardBtn
                    title='테마분석하기'
                    desc='테마에 대해 유사단어를 확인해보세요.'
                    img={Chart}
                    goto="/admin/system/thema"
                />
            </ButtonGridContainer>
        </LoadInView>
        <br />
        <br />
        <br />
        <br />
        <LoadInView>
            <div>관리자페이지:시스템: 데이터업로드/업데이트</div>
            <ButtonGridContainer>
                {/* <CardBtn
                    title='데이터 업로드하기'
                    desc='퀴즈문항, 학과분류체계, 학문프로파일을 업로드해보세요.'
                    img={Chart}
                    goto="/admin/system/upload"
                /> */}
                <CardBtn
                    title='데이터 업데이트하기'
                    desc='gsheet에서 데이터를 업데이트해보세요.'
                    img={Chart}
                    goto="/admin/system/update"
                />
            </ButtonGridContainer>
        </LoadInView>
    </Container>
  )
}

export default AdminCard

const Container = styled.div`
    max-width: 1280px;
    margin: 20px auto;
`


const ButtonGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px 50px;
`